import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { scrollProducts, textLabel } from "../components/functions";
import CategoriesMenu1 from "../components/CategoriesMenu1";
import StoreHeader from "../components/StoreHeader";
import Cart from "../components/Cart";
import { useLocation, useParams } from "react-router-dom";
import CategoriesMenu2 from "../components/CategoriesMenu2";
import CategoriesMenu2Button from "../components/CategoriesMenu2/CategoriesMenu2Button";
import CmsPopups from "../components/CmsPopups";
import Label from "../components/Label";
import Product from "../components/Product";
import SearchIcon from "../components/icons/SearchIcon";
import Banners from "../components/Banners";

function Store() {
  const SKIP_STORE_BRAND_POPUP_UNTIL_KEY = "skip-store-brand-popup-until";
  const {
    settings,
    courses,
    getTranslatedString,
    category,
    setCategory,
    cart,
    labels,
    lang,
    cartEnabled,
    setCartEnabled,
    storePopupVisible,
    setStorePopupVisible,
    hotel,
    hotelBrandSelectionRequired,
    hotelInfo,
    mainSettings,
    hasSavedBrandAtInit,
    brandSelectionAtOrderInit,
    openBrandSelectionPopup,
  } = useContext(AppContext);
  const [src, setSrc] = useState("");
  const [srcProducts, setSrcProducts] = useState([]);
  const location = useLocation();
  const hasOpenedBrandPopupRef = useRef(false);
  const [stickyCategoriesOffset, setStickyCategoriesOffset] = useState(0);
  const [viewportWidth, setViewportWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 0);
  const categoriesMenuType = Number(settings.website.categories_menu_type_new || 1);
  const isOnePage = (settings.website.products_loading_type || "onepage") === "onepage";
  const type3DesktopBreakpoint = 1200;
  const isType3Desktop = categoriesMenuType === 3 && viewportWidth >= type3DesktopBreakpoint;
  let params = useParams();

  let sclollTimeOut;

  useEffect(() => {
    const selectBrandOnOrderInit = brandSelectionAtOrderInit && mainSettings?.mandant?.childs?.length > 0;
    if (!selectBrandOnOrderInit || hasOpenedBrandPopupRef.current) return;
    if (hotel || hotelInfo || hotelBrandSelectionRequired) return;
    const skipUntil = parseInt(sessionStorage.getItem(SKIP_STORE_BRAND_POPUP_UNTIL_KEY) || "0", 10);
    if (skipUntil > Date.now()) {
      hasOpenedBrandPopupRef.current = true;
      return;
    }
    if (skipUntil > 0) {
      sessionStorage.removeItem(SKIP_STORE_BRAND_POPUP_UNTIL_KEY);
    }
    if (hasSavedBrandAtInit) {
      hasOpenedBrandPopupRef.current = true;
      return;
    }
    hasOpenedBrandPopupRef.current = true;
    openBrandSelectionPopup(location.pathname + location.search);
  }, [
    hotel,
    hotelInfo,
    hotelBrandSelectionRequired,
    brandSelectionAtOrderInit,
    mainSettings,
    openBrandSelectionPopup,
    location.pathname,
    location.search,
    hasSavedBrandAtInit,
  ]);

  useEffect(() => {
    console.log(params.categoryId);
    if (params.categoryId) scrollProducts(params.categoryId);
  }, []);

  useEffect(() => {
    if (!isOnePage) return;
    setCategory(false);
    document.getElementById("main").addEventListener("scroll", handleScroll);

    return () => {
      document.getElementById("main")?.removeEventListener("scroll", handleScroll);
    };
  }, [courses, isOnePage]);

  useEffect(() => {
    if (isOnePage) return;
    if (category) return;
    for (const course of courses) {
      const firstCategory = course.categories.find((c) => c.products.length > 0);
      if (firstCategory) {
        setCategory(firstCategory);
        break;
      }
    }
  }, [courses, isOnePage, category]);

  useEffect(() => {
    checks();
  }, [cart, storePopupVisible, cartEnabled]);

  useEffect(() => {
    console.log("cartEnabled set to", cartEnabled);
  }, [cartEnabled]);

  useEffect(() => {
    filter();
  }, [src]);

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const updateStickyCategoriesOffset = () => {
      if (categoriesMenuType === 2) {
        const menuButton = document.getElementById("categories-menu-2-button");
        setStickyCategoriesOffset(menuButton ? menuButton.offsetHeight : 0);
        return;
      }

      const menu = document.getElementsByClassName("categories-menu-1-container")[0];
      setStickyCategoriesOffset(menu ? menu.offsetHeight : 0);
    };

    updateStickyCategoriesOffset();
    window.addEventListener("resize", updateStickyCategoriesOffset);

    const observedEl =
      categoriesMenuType === 2
        ? document.getElementById("categories-menu-2-button")
        : document.getElementsByClassName("categories-menu-1-container")[0];
    let resizeObserver = null;
    if (observedEl && typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateStickyCategoriesOffset);
      resizeObserver.observe(observedEl);
    }

    return () => {
      window.removeEventListener("resize", updateStickyCategoriesOffset);
      if (resizeObserver) resizeObserver.disconnect();
    };
  }, [categoriesMenuType, courses]);

  const checks = () => {
    console.log("checks", cart.delivery_type, cart.shop_id, cart.selected_time);
    let valid = true;
    const isCapacityFull = cart?.slot_invalidation?.code == "capacity_full";
    if (cart) {
      if (!cart.delivery_type) valid = false;
      if (cart.delivery_type == "takeaway" && !cart.shop_id) valid = false;
      if (cart.delivery_type == "delivery") {
        if (!hotel && !cart.hotel_id) {
          if (!cart.selected_address || cart.selected_address.covered == 0) valid = false;
        } else {
        }
      }
      if (!cart.selected_time) valid = false;
    }
    console.log("checks", valid);
    if (!valid) {
      if (cartEnabled && !isCapacityFull) setStorePopupVisible(true);
    } else setCartEnabled(true);
  };

  const handleScroll = (e) => {
    clearTimeout(sclollTimeOut);
    sclollTimeOut = setTimeout(() => {
      const categoryBoxes = document.getElementsByClassName("category-box");
      if (categoryBoxes.length === 0) return;

      const headerHeight = document.getElementById("header")?.offsetHeight || 0;
      const menuHeight =
        categoriesMenuType === 2
          ? document.getElementById("categories-menu-2-button")?.offsetHeight || 0
          : document.getElementsByClassName("categories-menu-1-container")[0]?.offsetHeight || 0;
      const searchHeight = document.querySelector("#store .src")?.offsetHeight || 0;
      const activationY = headerHeight + menuHeight + searchHeight + 8;

      let selectedBox = null;
      let firstBelow = null;
      let lastAbove = null;

      for (const categoryBox of categoryBoxes) {
        const rect = categoryBox.getBoundingClientRect();
        if (rect.top <= activationY && rect.bottom > activationY) {
          selectedBox = categoryBox;
          break;
        }
        if (rect.top > activationY && !firstBelow) firstBelow = categoryBox;
        if (rect.top <= activationY) lastAbove = categoryBox;
      }

      if (!selectedBox) selectedBox = firstBelow || lastAbove;
      if (!selectedBox) return;

      let c = false;
      for (const course of courses) {
        for (const courseCategory of course.categories) {
          if ("category-box-" + courseCategory.id == selectedBox.id) c = courseCategory;
        }
      }

      if (c) {
        setCategory(c);
        const menuScroller = document.getElementsByClassName("categories-menu-1-container")[0];
        const menu1 = document.getElementsByClassName("categories-menu-1")[0];
        const activeButton = document.getElementById("category-button-" + c.id);
        if (menuScroller && menu1 && activeButton) {
          const left = Math.max(0, activeButton.offsetLeft - menu1.offsetLeft);
          menuScroller.scroll({
            left,
            behavior: "smooth",
          });
        }
      }
    }, 80);
  };

  function filter() {
    console.log("filter");
    let arr = [];
    if (src) {
      courses.map((course) =>
        course.categories.map((category) =>
          category.products.map((product) => {
            console.log(product.name, src, product.name.includes(src));
            if (
              settings?.menu_api?.disable_stock_check_customers != 1 &&
              product.stock !== false &&
              parseInt(product.stock) == 0
            )
              return;
            if (product.name.toLowerCase().includes(src.toLowerCase())) arr.push(product);
          }),
        ),
      );
    }
    arr.sort(function (a, b) {
      return a["name"] > b["name"] ? 1 : -1;
    });
    setSrcProducts(arr);
  }

  return (
    <>
      {cartEnabled && <StoreHeader setPopupVisible={setStorePopupVisible} />}
      {categoriesMenuType == 1 && <CategoriesMenu1 />}
      {categoriesMenuType == 3 && !isType3Desktop && (
        <div className="categories-menu-mobile-only">
          <CategoriesMenu1 />
        </div>
      )}
      {categoriesMenuType == 2 && <CategoriesMenu2Button />}
      <div className="promo-line">
        <div></div>
      </div>
      <div
        className="store-columns screen-container"
        style={{
          "--store-sticky-top": `${stickyCategoriesOffset}px`,
        }}
      >
        <div className="store-left-column">
          <Banners
            breakpoints={{
              // when window width is >= 320px
              320: {
                slidesPerView: 1,
              },
              // when window width is >= 1200px
              1200: {
                slidesPerView: 2,
              },
            }}
          />
          <div className={categoriesMenuType == 2 || isType3Desktop ? "store-subcolumns" : ""}>
            {(categoriesMenuType == 2 || isType3Desktop) && <CategoriesMenu2 />}
            <div id="store">
              <div className="src">
                <span>
                  <SearchIcon></SearchIcon>
                </span>
                <input
                  type="text"
                  placeholder={textLabel(labels, 202, lang)}
                  value={src}
                  onChange={(e) => setSrc(e.target.value)}
                />
                {src && <button onClick={() => setSrc("")}>x</button>}
              </div>
              {src && (
                <div>
                  <h1>
                    <Label number={201} />
                  </h1>
                  <div className="category-box">
                    <ProductsList products={srcProducts} />
                  </div>
                </div>
              )}
              {!src && isOnePage &&
                courses.map((course, i) => (
                  <div key={i}>
                    {course.name && <h1>{getTranslatedString(course, "name")}</h1>}
                    {course.categories.map(
                      (category, n) =>
                        category.products.length > 0 && (
                          <div key={n} id={"category-box-" + category.id} className="category-box">
                            <div id={"category-" + category.id} className="anchor"></div>
                            <div className="category-header">
                              {settings.website.show_category_images == 1 && category.img && (
                                <div className="category-image">
                                  <img src={category.img} alt={getTranslatedString(category, "name")} />
                                </div>
                              )}
                              <h2>{getTranslatedString(category, "name")}</h2>
                            </div>
                            <p className="smoot">{getTranslatedString(category, "description")}</p>
                            <ProductsList products={category.products} category={category} />
                          </div>
                        ),
                    )}
                  </div>
                ))}
              {!src && !isOnePage && category && (
                <div>
                  <div className="category-header">
                    {settings.website.show_category_images == 1 && category.img && (
                      <div className="category-image">
                        <img src={category.img} alt={getTranslatedString(category, "name")} />
                      </div>
                    )}
                    <h2>{getTranslatedString(category, "name")}</h2>
                  </div>
                  <p className="smoot">{getTranslatedString(category, "description")}</p>
                  <ProductsList products={category.products} category={category} />
                </div>
              )}
            </div>
          </div>
        </div>
        <Cart cartEnabled={cartEnabled} setCartEnabled={setCartEnabled} />
      </div>
      <CmsPopups mode="shop" shopId={cart.shop_id ? cart.shop_id : false} />
    </>
  );
}

function ProductsList({ products, category = false }) {
  return (
    <div className="products">
      {products.map((product) => (
        <Product key={product.id} product={product} category={category} />
      ))}
    </div>
  );
}

export default Store;
